import { I18nextProvider } from 'react-i18next';
import i18n from '../locales/i18n';

export const TranslationProvider = ({ children }) => {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};
